import React from 'react';
import loadable from '@loadable/component';

import { Helpers } from '../core/src/helpers';
import { loadGraphQLData } from '../page';

const VWAContainer = loadable(() => Helpers.retryFunc(() => import('./vwa-container')));
const BeHPTracker = loadable(() => Helpers.retryFunc(() => import('./components/behp-tracker')));

const VWA = props => {
    return (
        <>
            <VWAContainer {...props} />
            <BeHPTracker />
        </>
    );
};

export default {
    component: VWA,
    loadData: loadGraphQLData,
};
